import 'babel-polyfill'

import Vue from 'vue'
import axios from 'axios'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import VueYouTubeEmbed from 'vue-youtube-embed'
import VueQuillEditor from 'vue-quill-editor'
import VueLazyload from 'vue-lazyload'
import vClickOutside from 'v-click-outside'
import { PATH_COURSE_NOT_FOUND, PATH_FORBIDDEN, PATH_MASTER_AUTH_REQUIRED, ERROR_CODES } from 'globalUtils/constants'

import './styles'

Vue.use(Element, { locale })
Vue.use(VueYouTubeEmbed)
Vue.use(VueQuillEditor)
Vue.use(vClickOutside)

const loadingGif = require('./assets/loading.gif')

Vue.use(VueLazyload, {
  preLoad: 1,
  loading: loadingGif,
  attempt: 1,
})

Vue.config.productionTip = false
axios.defaults.baseURL = '/api'

axios.interceptors.response.use(
  response => response,
  (error) => {
    const { response } = error

    // Check for specific error codes for global redirects
    if (response && response.status === ERROR_CODES.COURSE_NOT_FOUND) {
      window.location.href = `error${PATH_COURSE_NOT_FOUND}`
    } else if (response && response.status === ERROR_CODES.FORBIDDEN) {
      window.location.href = `error${PATH_FORBIDDEN}`
    } else if (response && response.status === ERROR_CODES.MASTER_AUTH_REQUIRED) {
      window.location.href = `error${PATH_MASTER_AUTH_REQUIRED}`
    }
    return Promise.reject(error)
  },
)



// WEBPACK FOOTER //
// ./client/main.js